import { useQuery } from '@tanstack/react-query';
import { WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS } from '../constants';
import { fetchWebsiteAnalyticsProducts } from '../services/websiteAnalytics.api';
import type { WebsiteAnalyticsDays } from '../types';

export function useWebsiteAnalyticsProducts(days: WebsiteAnalyticsDays, enabled: boolean) {
  return useQuery({
    queryKey: ['website-analytics', 'products', days],
    queryFn: () => fetchWebsiteAnalyticsProducts(days),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
